interface ExitIconProps {
  click: () => void
}

export default function ExitIcon({click}: ExitIconProps) {
  return (
    <svg
      className="exitIcon"
      onClick={click}
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="2.12132"
        y1="2.4707"
        x2="20.0588"
        y2="20.4082"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <line
        x1="1.5"
        y1="-1.5"
        x2="26.8675"
        y2="-1.5"
        transform="matrix(-0.707107 0.707107 0.707107 0.707107 22 2.4707)"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  )
}
